module.exports = __webpack_public_path__ + "static/media/web-hyperlink.a450cea6.svg";